// src/pages/ManageDailyAttendance.jsx
import { useRef, useState } from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import { useDispatch, useSelector } from "react-redux";
import { downloadAdminAttendanceCSV } from "../redux/slices/dailyAttendanceSlice";
import Toast from "../components/Toast";
import DailyAdminAttendance from "../components/DailyAdminAttendance";
import DynamicModal from "../components/DynamicModal";
import AddAttendanceAdminModal from "../components/AddAttendanceAdminModal";

const ManageDailyAttendance = () => {
  const dispatch = useDispatch();
  const [showAddModal, setShowAddModal] = useState(false);

  const attendanceRef = useRef();

  const {
    isDownloadingAdminCSV,
    downloadAdminCSVError,
    successMessage,
    isAddingAttendanceAdmin,
  } = useSelector((state) => state.dailyAttendance);

  const handleDownloadCSV = () => {
    // Get the local time difference in hours (offset from UTC)
    const localTimeDifference = -new Date().getTimezoneOffset() / 60;

    if (attendanceRef.current) {
      const filterParams = attendanceRef.current.getFilterParams();
      // Add the local_time_difference to the params
      const paramsWithTimeZone = {
        ...filterParams,
        local_time_difference: localTimeDifference,
      };
      dispatch(downloadAdminAttendanceCSV(paramsWithTimeZone));
    } else {
      dispatch(
        downloadAdminAttendanceCSV({
          local_time_difference: localTimeDifference,
        }),
      );
    }
  };

  const handleAddAttendance = () => {
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };

  const handleSaveAttendance = async (attendanceData) => {
    // Refresh the table after successful save
    if (attendanceRef.current && attendanceRef.current.refreshData) {
      attendanceRef.current.refreshData();
    }
  };

  return (
    <>
      {downloadAdminCSVError && (
        <Toast
          show={!!downloadAdminCSVError}
          message={downloadAdminCSVError}
          type="error"
          onClose={() => {}}
          duration={3000}
        />
      )}

      <MasterLayout>
        <DefaultTopBar
          title="Facility Attendance"
          btnText="Add Attendance"
          btnLink="#"
          isApiButton={true}
          onBtnClick={handleAddAttendance}
          isBtnLoading={isAddingAttendanceAdmin}
          btnLoadingText="Adding..."
          btnText2="Download CSV"
          btnLink2="#"
          isApiButton2={true}
          onBtn2Click={handleDownloadCSV}
          isBtn2Loading={isDownloadingAdminCSV}
          btn2LoadingText="Downloading..."
        />

        <DailyAdminAttendance ref={attendanceRef} />

        <DynamicModal
          show={showAddModal}
          handleClose={handleCloseAddModal}
          title="Add Facility Attendance"
          modalWidth="500px"
          content={
            <AddAttendanceAdminModal
              onClose={handleCloseAddModal}
              onSave={handleSaveAttendance}
              isSaving={isAddingAttendanceAdmin}
            />
          }
        />
      </MasterLayout>
    </>
  );
};

export default ManageDailyAttendance;
